import {Grid, Paper, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import React, {useState} from "react";
import Flag from 'react-world-flags'
import LanguageFreeSelectionDropdownView from "./LanguageFreeSelectionDropdownView";

function LanguageSelectionGridView({languages, languageSelectedCallback}) {

    const theme = useTheme();
    const [isFreeLanguageSelecting, setIsFreeLanguageSelecting] = useState(false);

    return <div>
        <Typography variant="h4" fontWeight="bold" align="center" sx={{mb: 4}}>Select language</Typography>
        <Grid container spacing={4} justifyContent="center">
            {languages.map(([language, code], index) => (
                <Grid item key={index} xs={6} sm={6} md={4} lg={3}>
                    <Paper elevation={5}
                           square={false}
                           onClick={() => languageSelectedCallback({language, code})}
                           sx={{backgroundColor: theme.palette.neutral.main, borderRadius: 2, height: 200, cursor: 'pointer', transition: "transform 0.15s ease-in-out", "&:hover": {transform: "scale3d(1.05, 1.05, 1)"}}}
                    >
                        <Flag code={code} style={{borderRadius: '0.7em 0.7em 0 0'}}/>
                        <Typography variant="h4" align="center" fontWeight="bold" sx={{mt: 2}}>{language}</Typography>
                    </Paper>
                </Grid>
            ))}
            <Grid item xs={6} sm={6} md={4} lg={3}>
                <Paper elevation={5}
                       square={false}
                       onClick={() => setIsFreeLanguageSelecting(true)}
                       sx={{backgroundColor: theme.palette.neutral.main, borderRadius: 2, height: "100%", cursor: 'pointer', position: "relative", display: "flex", flexDirection: "column", alignItems: "center", pt: 1, transition: "transform 0.15s ease-in-out", "&:hover": {transform: "scale3d(1.05, 1.05, 1)"}}} >
                    <img src={`${process.env.REACT_APP_BACKEND_ENTRYPOINT}static/images/earth-icon.png`} height='100vh' />
                    <Typography variant="h4" align="center" fontWeight="bold" sx={{position: "absolute", bottom: 0}}>Other</Typography>
                </Paper>
            </Grid>
        </Grid>
        {isFreeLanguageSelecting && (
            <LanguageFreeSelectionDropdownView confirmationCallback={languageSelectedCallback}
                                               cancelCallback={() => setIsFreeLanguageSelecting(false)}/>
        )}
    </div>

}

export default LanguageSelectionGridView;